// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { getCountry, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getReceiptAmountLocalTotal } from '@tectonics/prs/receipts/receipt';
import { getMoneyFormat } from '@tectonics/look-and-feel/shopify/commons/money-format';
import { amountToCurrencyString } from '@tectonics/prs/money';
import { useCurrentReceipt } from '@tectonics/prs/receipts';
import { translate } from '@tectonics/translate';

export function MobileTotalAmount(): Node {
  const incomingPayment = useIncomingPayment();
  const receipt = useCurrentReceipt();
  const decimalFormat = getMoneyFormat(getCountry(incomingPayment));
  const formatAmount = amountToCurrencyString(decimalFormat);

  return (
    <Root>
      <FlexDiv align="left">{translate('volcanes.total')}</FlexDiv>
      <FlexDiv align="right">{formatAmount(getReceiptAmountLocalTotal(receipt))}</FlexDiv>
    </Root>
  );
}

const Root = styled.div`
  font-family: ${props => props.theme.fontFamily.display};
  color: ${props => props.theme.colors.secondary(30)};
  border: 1px solid hsl(210, 17%, 88%);
  border-radius: 5px;
  display: none;
  font-size: 1.4em;
  width: 100%;
  margin: 1em auto;
  padding: 1em;
  @media (max-width: 840px) {
    display: flex;
    gap: 16px;
  }
`;

const FlexDiv = styled.div`
  flex-basis: 50%;
  ${props => props.align !== null ? `text-align:${props.align}` : 'text-align:center'}
`;
